var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.692308,
    y: 0.692308,
    width: 70.6154,
    height: 70.6154,
    rx: 7.30769,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.692308,
    y: 0.692308,
    width: 70.6154,
    height: 70.6154,
    rx: 7.30769,
    stroke: "#8E8E8E",
    strokeWidth: 1.38462
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3088_4986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6021 35.9802L60.5903 31.1639C61.4147 29.1658 60.6759 26.8923 58.8332 25.7614L53.7439 22.7164L52.5973 17.97C52.0881 15.8649 50.1384 14.4615 48.0005 14.6297L42.1772 15.0804L38.8414 12.1265C38.0193 11.425 37.0101 11.0748 36.0003 11.0752C34.992 11.0756 33.9831 11.4253 33.1593 12.1251L29.8233 15.0804L24 14.6297C21.8863 14.4814 19.911 15.8662 19.4561 17.7974C19.5666 17.454 17.8658 22.7403 17.7717 23.033L13.1681 25.7599C11.3241 26.8923 10.5853 29.1657 11.411 31.1653L13.3977 35.9802L11.4126 40.7937C10.5854 42.7947 11.3255 45.0667 13.1682 46.1976L18.2524 49.2212L19.4033 53.9891C19.9096 56.0928 21.8507 57.489 24 57.3294L29.7605 56.8844L33.1592 59.8727C33.9822 60.5743 34.9906 60.9252 36.0003 60.9252C37.0086 60.9252 38.0185 60.5743 38.8414 59.8726L42.24 56.8843L48.0005 57.3293C50.177 57.5018 52.091 56.0941 52.5973 53.989L53.7439 49.2426L58.8332 46.1976C60.6744 45.0667 61.4132 42.7947 60.5888 40.7937L58.6021 35.9802Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2407 56.8843L48.0012 57.3293C50.1777 57.5018 52.0916 56.0941 52.5979 53.989L53.7446 49.2426L58.8338 46.1976C60.6751 45.0667 61.4139 42.7947 60.5895 40.7937L58.6028 35.9802L60.5909 31.1639C61.4153 29.1658 60.6765 26.8923 58.8338 25.7614L53.7446 22.7164L52.5979 17.97C52.0888 15.8649 50.1391 14.4615 48.0012 14.6297L42.1779 15.0804L38.842 12.1265C38.02 11.425 37.0107 11.0748 36.001 11.0752V60.9252C37.0093 60.9252 38.0191 60.5743 38.842 59.8726L42.2407 56.8843Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9995 52.0645C44.8719 52.0645 52.0645 44.8719 52.0645 35.9995C52.0645 27.1271 44.8719 19.9346 35.9995 19.9346C27.1271 19.9346 19.9346 27.1271 19.9346 35.9995C19.9346 44.8719 27.1271 52.0645 35.9995 52.0645Z",
    fill: "#02C66A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0659 35.9995C52.0659 27.1413 44.8592 19.9346 36.001 19.9346V52.0645C44.8592 52.0645 52.0659 44.8577 52.0659 35.9995Z",
    fill: "#00875A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3348 30.586C43.7644 30.0156 42.8401 30.0156 42.2696 30.586L36 36.8557L34.5396 38.3161L29.7303 33.5068C29.1599 32.9364 28.2356 32.9364 27.6651 33.5068C27.0947 34.0773 27.0947 35.0016 27.6651 35.572L33.5069 41.4138C33.7922 41.6991 34.1659 41.8417 34.5395 41.8417C34.9131 41.8417 35.2868 41.6991 35.572 41.4138L35.9999 40.9859L44.3347 32.6511C44.9054 32.0807 44.9054 31.1565 44.3348 30.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3358 30.586C43.7653 30.0156 42.841 30.0156 42.2706 30.586L36.001 36.8557V40.986L44.3358 32.6512C44.9063 32.0807 44.9063 31.1565 44.3358 30.586Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3088_4986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.85,
    height: 49.85,
    fill: "white",
    transform: "translate(11.0752 11.0752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanSuccess);
export default __webpack_public_path__ + "static/media/loanSuccess.cd72d7784978c77363e75da9d87b68c0.svg";
export { ForwardRef as ReactComponent };